import Link from 'next/link';
import Container from './Container';

/* This example requires Tailwind CSS v2.0+ */
const faqs = [
  {
    id: 1,
    question: 'What tokens can I flip?',
    answer: () => {
      return (
        <p>
          For a full list of the community tokens you can flip, checkout the dropdown next to "Bet Amount" above or read more about them in our{' '}
          <a
            href='https://docs.shittykitties.art/website-utilities/shitty-flips#what-tokens-can-i-bet'
            className='font-bold underline transition-opacity duration-200 text-primary-500 hover:opacity-50'
          >
            Shitty Docs
          </a>
          .
        </p>
      );
    },
  },
  {
    id: 2,
    question: 'What are the fees for flips?',
    answer: 'All Flips have a 3% fee rounded down. For example, if you flip 100 Shitty Treats, it will actually cost you 103 Shitty Treats.',
  },
  {
    id: 3,
    question: 'What is the max bet?',
    answer: `The max bet is different for each token and is dynamic based on the current supply of the token in the Flip wallet.`,
  },
  {
    id: 4,
    question: 'Why is Pera Wallet disabled for Shitty Flips?',
    answer: `An issue sometimes occurs when using Pera Wallet where users will transfer Shitty Treats, the connection will error out, and then the Shitty Treats are lost. Pera Wallet has been disabled until this bug is fixed.`,
  },
];

export default function FlipsInfo() {
  return (
    <div className='mt-12 md:mt-36'>
      <div className='rounded-lg bg-neutral-900'>
        <div className='px-4 py-16 mx-auto sm:py-24 sm:px-6 lg:px-8'>
          <h2 className='text-3xl font-extrabold text-neutral-50'>How do Shitty Flips work?</h2>
          <div className='pt-10 mt-6 border-t border-opacity-25 border-neutral-300'>
            <dl className='space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-12'>
              {faqs.map((faq) => (
                <div key={faq.id}>
                  <dt className='text-lg font-medium leading-6 text-neutral-50'>{faq.question}</dt>
                  <dd className='mt-2 text-base text-neutral-400'>{typeof faq.answer === 'function' ? <faq.answer /> : faq.answer}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
}
